const ROOT = "pollsViewer";
const PRESET_SELECTOR_MODAL = "presetSelectorModal";
const TEXT_LIST_OPTION = "textListOption";
const IMAGE_AND_LIST_OPTION = "imageAndListOption";
const IMAGE_GRID_OPTION = "imageGridOption";

export { IMAGE_AND_LIST_OPTION, IMAGE_GRID_OPTION, PRESET_SELECTOR_MODAL, ROOT, TEXT_LIST_OPTION };
//# sourceMappingURL=dataHooks.js.map
